import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaEventService } from '../../../services/ga-event.service';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { LOV_OEM_ACSL_RANKING, LovService } from '../../../services/lov.service';
import { ILov } from '../../../../../type_definitions/datatypes';
import * as _ from 'underscore';
import { FormattingService } from '../../../services/formatting.service';

@Component({
  selector: 'set-oem-ranking-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html',
  styleUrls: ['./set-oem-ranking-action.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SetOEMRankingActionComponent extends BaseReportActionsDialog implements OnInit {
  private rankingField: IExtraFieldConfigurationObject;

  constructor(
    private formlyService: GaFormlyService,
    private lovService: LovService,
    private formattingService: FormattingService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.fields = this.createFields();

    // fill fields
    this.fillFields();
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    const fullWidthClass:string = 'col-sm-12';
    return [
      this.rankingField = this.formlyService.aSelect('ranking', 'Ranking')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .withFormat(this.formattingService.formatLov)
        .build()
    ];
  }

  private fillFields(): void {
    this.formlyService.fillField(
      this.rankingField,
      this.lovService.list(LOV_OEM_ACSL_RANKING)
        .then((rankings: ILov[]) => {
          _.forEach(rankings, (ranking: ILov) => {
            // add new object key to options for label class as specified in formly-field-radio component
            (<any>ranking).labelClass = `badge ${this.formattingService.getRankingLabelClass(ranking)}`;
          });

          return rankings;
        })
    );
  }
}